import React from 'react';
import LocationTemplate from './LocationTemplate';

const WaynesvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Waynesville"
      stateName="North Carolina"
      countyName="Haywood"
      zipCodes={["28786", "28785"]}
      latitude={35.4887}
      longitude={-82.9882}
      population={10362}
      historicalFact="Named after Revolutionary War General Anthony Wayne; gateway to the Great Smoky Mountains."
      nearbyTowns={[
        "Maggie Valley, NC",
        "Canton, NC",
        "Clyde, NC",
        "Lake Junaluska, NC",
        "Sylva, NC",
        "Franklin, NC",
        "Cherokee, NC",
        "Asheville, NC"
      ]}
    />
  );
};

export default WaynesvillePage;